import { useEffect } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ListTodo, CreditCard, HandCoins, MapPin, TrendingUp } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function MobileLayout() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // 检查登录状态
    const token = localStorage.getItem('token')
    if (!token) {
      navigate('/mobile/login')
    }
  }, [navigate])

  // 处理Tab点击，确保不触发任何可能导致退出PWA的行为
  const handleTabClick = (path: string, e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    // 如果已经在当前页面，不做任何操作
    if (location.pathname === path) {
      return
    }

    // 使用 navigate 进行客户端路由
    navigate(path)
  }

  const tabs = [
    { icon: ListTodo, label: '任务', path: '/mobile/task' },
    { icon: CreditCard, label: '充值', path: '/mobile/rechargeStatus' },
    { icon: HandCoins, label: '提现', path: '/mobile/withdraw' },
    { icon: MapPin, label: '地址', path: '/mobile/addresses' },
    { icon: TrendingUp, label: '趋势', path: '/mobile/trend' },
  ]

  return (
    <div className="flex flex-col h-full min-h-screen bg-background">
      {/* 主内容区 - 可滚动，底部留出tab栏空间 */}
      <main
        className="flex-1 overflow-y-auto overflow-x-hidden"
        style={{
          WebkitOverflowScrolling: 'touch',
          paddingBottom: 'calc(64px + max(env(safe-area-inset-bottom), 8px))'
        }}
      >
        <Outlet />
      </main>

      {/* 底部导航栏 - 固定在底部，PWA全屏模式优化 */}
      <nav
        className="fixed bottom-0 left-0 right-0 border-t border-border bg-card/95 backdrop-blur-md shadow-lg z-50"
        style={{
          paddingBottom: 'max(env(safe-area-inset-bottom), 8px)',
        }}
      >
        <div className="flex justify-around items-center h-16 px-2">
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.path
            return (
              <Button
                key={tab.path}
                variant="ghost"
                className={`flex-1 flex flex-col items-center justify-center gap-1 h-full rounded-lg transition-all ${
                  isActive
                    ? 'text-primary bg-primary/10 scale-105'
                    : 'text-muted-foreground hover:text-foreground hover:bg-accent/50'
                }`}
                onClick={(e) => handleTabClick(tab.path, e)}
                style={{ WebkitTapHighlightColor: 'transparent' }}
                type="button"
              >
                <tab.icon className={`h-5 w-5 transition-transform ${isActive ? 'scale-110' : ''}`} />
                <span className={`text-xs transition-all ${isActive ? 'font-semibold' : ''}`}>
                  {tab.label}
                </span>
                {isActive && (
                  <div className="absolute bottom-0 w-12 h-1 bg-primary rounded-t-full" />
                )}
              </Button>
            )
          })}
        </div>
      </nav>
    </div>
  )
}
